import React from "react";
import { Box, Grid, Chip } from "@mui/material";
import {
  InfoOutlined,
  TextFieldsOutlined,
  CategoryOutlined,
  DateRangeOutlined,
  ToggleOnOutlined,
} from "@mui/icons-material";

import { useSmsTemplateDetailContext } from "contexts/SmsTemplateDetailContext";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import { localizeDateTimeShort } from "utils/dateFormats";
import { getTemplateByCode } from "constants/smsTemplateConstants";
import Status from "components/Shared/Status";

const SmsTemplateBasicDetail = () => {
  const { smsTemplateDetail, loadingSmsTemplate } = useSmsTemplateDetailContext();

  const templateObj = smsTemplateDetail?.applicableFor
    ? getTemplateByCode(smsTemplateDetail.applicableFor)
    : null;

  return !loadingSmsTemplate ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6} md={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Template Name"
            subtitle={smsTemplateDetail?.templateName || "N/A"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <InformationTile
            icon={() => <TextFieldsOutlined color="primary" />}
            title="Content"
            subtitle={smsTemplateDetail?.content || "N/A"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <InformationTile
            icon={() => <CategoryOutlined color="primary" />}
            title="Type"
            subtitle={smsTemplateDetail?.type || "N/A"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Applicable For"
            subtitle={
              templateObj
                ? templateObj.template.substring(0, 50) +
                  (templateObj.template.length > 50 ? "..." : "")
                : "N/A"
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <InformationTile
            icon={() => <DateRangeOutlined color="primary" />}
            title="Created At"
            subtitle={
              smsTemplateDetail?.createdAt
                ? localizeDateTimeShort(smsTemplateDetail.createdAt)
                : "N/A"
            }
          />
        </Grid>
       <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Status"
          >
            <Status isActive={smsTemplateDetail?.isActive} />
          </InformationTile>
        </Grid>
        <Grid item xs={12}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Variables"
            subtitle={
              smsTemplateDetail?.variables?.length ? (
                <Box display="flex" gap={1} flexWrap="wrap">
                  {smsTemplateDetail.variables.map((variable, index) => (
                    <Chip key={index} label={variable} color="primary" variant="outlined" />
                  ))}
                </Box>
              ) : (
                "N/A"
              )
            }
          />
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default SmsTemplateBasicDetail;